namespace RecordShield.Workspace {
    export interface SerialKeyItemsRow {
        Id?: number;
        ProductSerialId?: number;
        KeyGenId?: number;
        KeyGenAsId?: number;
        ProductItemId?: number;
        TenantId?: number;
        ProductSerialProductId?: number;
        ProductSerialSerialKey?: string;
        ContentKey?: number;
        ProductItemName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace SerialKeyItemsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductItemName';
        export const localTextPrefix = 'Workspace.SerialKeyItems';

        export namespace Fields {
            export declare const Id: string;
            export declare const ProductSerialId: string;
            export declare const KeyGenId: string;
            export declare const KeyGenAsId: string;
            export declare const ProductItemId: string;
            export declare const TenantId: string;
            export declare const ProductSerialProductId: string;
            export declare const ProductSerialSerialKey: string;
            export declare const ContentKey: string;
            export declare const ProductItemName: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'ProductSerialId', 'KeyGenId', 'KeyGenAsId', 'ProductItemId', 'TenantId', 'ProductSerialProductId', 'ProductSerialSerialKey', 'ContentKey', 'ProductItemName', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
